import { User } from "@interfaces/user.interface";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "../providers/TanstackQueryProvider";

export type AuthState = {
  user?: User;
  setUser: (user: User) => void;
  signOut: () => void;
  _hasHydrated: boolean;
  setHasHydrated: (state: boolean) => void;
};

export const useAuthUser = create<AuthState, [["zustand/persist", AuthState]]>(
  persist(
    (set, get) => ({
      setUser: (user: User) => set({ user }),
      signOut: () => {
        queryClient.removeQueries();
        set({ user: undefined });
        localStorage.clear();
      },
      _hasHydrated: false,
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state,
        });
      },
    }),
    {
      name: "auth-storage", // name of the item in the storage (must be unique)
      onRehydrateStorage: (_) => {
        return (state, err) => {
          if (err) {
            console.log("an error happened during hydration", err);
          } else {
            state?.setHasHydrated(true);

            if (state?.user) {
              state.setUser(state.user);
            }
            console.log("CreateStore", state);
          }
        };
      },
    }
  )
);
